// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__245jJ","label":"Category_label__1TS8F","content":"Category_content__7Keh_","header":"Category_header__1Z3MV","location":"Category_location__3mjSx"};